export const LARGE_MEDIA_QUERY = '1150';
export const SMALL_MEDIA_QUERY = '600';

export const toolTipStyles = {
  closeOnClick: true,
  openDelay: 0,
  placement: 'top',
};

export const textDashedUnderlineStyles = {
  fontSize: 'md',
  fontWeight: 'normal',
  textDecorationColor: 'grey.lighter',
  textDecorationLine: 'underline',
  textDecorationStyle: 'dashed',
  textDecorationThickness: '1px',
  textUnderlineOffset: '4px',
};

export const columnStyles = {
  color: 'black.lighter',
  fontSize: 'md',
  fontWeight: 'normal',
  lineHeight: '21px',
  width: '50%',
};

export const baseHeadingStyles = { fontSize: 'lg', fontWeight: 'semibold' };
